import React from 'react';
import Player from './Player.js';
import ResizerStore from './../stores/ResizerStore';
import TeamsStore from './../stores/TeamsStore';
import AppConstants from './../constants/AppConstants';
import AppDispatcher from './../dispatcher/AppDispatcher';
import styleHelper from './../helpers/style';
import arrayHelper from './../helpers/array';
import data from './../data/data';


/**
 * Teams component
 * The top level component for the app
 * @class
 */
const Teams = React.createClass({
  displayName: 'Teams',
  categoryIteration: 0,
  animateInHeadersTimeout: 0,
  largeBreakpoint: 768,
  currentLayout: 'small',
  previousSortCategoryId: -1,
  team1Rows: 0,
  cycleCount: 0,
  adViewCount: 0,


  propTypes: {
    imagePath: React.PropTypes.string.isRequired,
    data: React.PropTypes.array.isRequired,
    categoryData: React.PropTypes.array.isRequired,
    touch: React.PropTypes.bool.isRequired,
    supportsCssTransforms3d: React.PropTypes.bool.isRequired,
    isIOS: React.PropTypes.bool.isRequired,
  },


  /**
   * Get initial state object
   * @returns {Object} initial state
   */
  getInitialState() {
    return {
      sortCategory: data.categories[0],
      windowSize: {
        width: 0,
        height: 0,
      },
      transitionSort: false,
      currentSortCategory: data.categories[0],
      sortStyles: [],
    };
  },


  /**
   * Called after component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    const _this = this;

    ResizerStore.addChangeListener(this._onResizerChange);
    TeamsStore.addChangeListener(this._onTeamsChange);
    this._setSortStyles();
    this._onResizerChange();
    this._onTeamsChange();

    setTimeout(function () {
      _this.setState({ shuffledPlayerData: _this._getShuffledPlayerData() });
    }, 10);
  },


  /**
   * Called right before component unmounts from DOM
   * @returns {undefined} undefined
   */
  componentWillUnmount() {
    ResizerStore.removeChangeListener(this._onResizerChange);
    TeamsStore.removeChangeListener(this._onTeamsChange);
  },


  /**
   * Renders component
   * @returns {ReactElement} A React element
   */
  render() {
    const actionText = this.props.touch ? 'Tap' : 'Click';
    const hideInstructionsClass =
      (this.state.sortCategory.id !== 0 || this.cycleCount > 10) ?
      ' hide-instructions' : '';
    const hideHeadersClass = !this.state.showHeaders ?
      ' hide-headers' : '';
    const headersAnimateClass = this.state.transitionSort ?
      ' transition-sort' : '';
    const className = 'component-teams' +
      headersAnimateClass +
      hideHeadersClass +
      hideInstructionsClass;
    const currentCategory = this.state.currentSortCategory;
    const sortTitle = currentCategory ?
      currentCategory.title : '';
    const team1Title = currentCategory ?
      currentCategory.divisions[0].title : '';
    const team2Title = currentCategory ?
      currentCategory.divisions[1].title : '';

    const players = this._renderPlayers();

    return (React.createElement("div", {className: className}, 
      React.createElement("div", {className: "sort-title-wrapper"}, 
        React.createElement("div", {className: "sort-title"}, sortTitle)
      ), 
      React.createElement("div", {className: "teams-wrapper"}, 
        React.createElement("div", {className: "team-1-area"}, 
          React.createElement("div", {className: "header-wrapper"}, 
            React.createElement("div", {className: "header"}, 
              React.createElement("div", {className: "title"}, team1Title)
            )
          )
        ), 
        React.createElement("div", {className: "sep"}, 
          React.createElement("div", {className: "line"}), 
          React.createElement("div", {className: "line-2"})
        ), 
        React.createElement("div", {className: "instructions"}, 
          actionText, " to refresh lineups"
        ), 
        React.createElement("div", {className: "team-2-area"}, 
          React.createElement("div", {className: "header-wrapper"}, 
            React.createElement("div", {className: "header"}, 
              React.createElement("div", {className: "title"}, team2Title)
            )
          )
        )
      ), 
      React.createElement("div", {className: "player-wrapper"}, 
        players
      )
    ));
  },


  _renderPlayers() {
    this._setSortStyles();

    const players = [];
    const sortStyles = this.sortStyles;

    for (const value of this.props.data) {
      const style = sortStyles ? sortStyles[value.id] : {};

      const player = (
        React.createElement(Player, {
          windowSize: this.state.windowSize, 
          currentCategory: this.state.currentSortCategory, 
          imagePath: this.props.imagePath, 
          className: '', 
          ref: 'player' + value.id, 
          key: 'player-' + value.id, 
          data: value, 
          style: style}
        )
      );

      players.push(player);
    }

    return players;
  },

  _getShuffledPlayerData() {
    const dataCopy = this.props.data.slice();

    return arrayHelper.shuffle(dataCopy);
  },


  /**
   * Renders players in a grid for the current category
   * @returns {Array<Object>} An array of React elements
   */
  _setSortStyles() {
    const team1AreaElement = document.getElementsByClassName('team-1-area')[0];
    const windowSize = this.state.windowSize;

    const categoryId = this.state.sortCategory.id;
    this.sortStyles = {
      categoryId,
    };

    const shuffledData = this.state.shuffledPlayerData;
    let gridColumns = 6;
    let team1RowInc = 0;
    let team1ColInc = 0;
    let team2RowInc = 0;
    let team2ColInc = 0;
    let team1PlayerCount = 0;
    let team2PlayerCount = 0;

    if (shuffledData) {
      for (const value of shuffledData) {
        const playerDivisionId = this._findDivisionId(value, categoryId);

        if (playerDivisionId === 1) {
          team1PlayerCount++;
        }

        if (playerDivisionId === 2) {
          team2PlayerCount++;
        }
      }

      this.evenRows = false;
      this.maxPlayerCount = team1PlayerCount;
      if (team2PlayerCount > team1PlayerCount) {
        this.maxPlayerCount = team2PlayerCount;
      }
      this.team1PlayerCount = team1PlayerCount;
      this.team2PlayerCount = team2PlayerCount;
      this.team1Rows = Math.ceil(team1PlayerCount / 6);
      this.team2Rows = Math.ceil(team2PlayerCount / 6);

      const itemSize = this._getItemSize();
      const columnWidth = itemSize.width;
      const rowHeight = itemSize.height;

      for (const value of shuffledData) {
        let mobileTeam2TopOffset = ((this.team1Rows - 3) * itemSize.height);
        if (this.team1Rows === this.team2Rows) {
          mobileTeam2TopOffset = 0;
          this.evenRows = true;
        }
        const playerDivisionId = this._findDivisionId(value, categoryId);
        let topStartPos = 95;
        let leftPos = 0;
        let topPos = 0 + mobileTeam2TopOffset;
        let style = {};

        if (windowSize.width > this.largeBreakpoint) {
          gridColumns = 4;

          if (team1PlayerCount > 12 || team2PlayerCount > 12) {
            gridColumns = 5;
          }

          topStartPos = 160;
        }

        if (playerDivisionId === 1) {
          leftPos = team1ColInc * columnWidth;

          if (windowSize.width <= this.largeBreakpoint) {
            leftPos += 15;
          } else {
            leftPos += 75;
          }

          topPos = topStartPos + (team1RowInc * rowHeight);
        }

        if (playerDivisionId === 2) {
          leftPos = team2ColInc * columnWidth;
          topStartPos = (windowSize.height / 2) + 70 + mobileTeam2TopOffset;
          if (this.team1Rows <= 3) {
            if (this.props.isIOS) {
              topStartPos += 17;
            } else {
              topStartPos += 10;
            }
          }

          if (this.props.isIOS && team1AreaElement) {
            // hack to accomodate browser chrome appearing/dissappearing on iOS
            topStartPos = team1AreaElement.offsetHeight + 105 + mobileTeam2TopOffset;
          }

          if (windowSize.width <= this.largeBreakpoint) {
            leftPos += 15;
          } else {
            topStartPos = 160;
            leftPos += ((windowSize.width / 2) + 105);
          }

          topPos = topStartPos + (team2RowInc * rowHeight);
        }

        // make sure players snap to whole pixels so fonts are legible
        leftPos = Math.round(leftPos);
        topPos = Math.round(topPos);

        style = styleHelper.getTranslateStyle(leftPos,
          topPos,
          0,
          this.props.supportsCssTransforms3d);

        this.sortStyles[value.id] = style;

        if (playerDivisionId === 1) {
          team1ColInc++;
          if (team1ColInc === gridColumns) {
            team1ColInc = 0;
            team1RowInc++;
          }
        }

        if (playerDivisionId === 2) {
          team2ColInc++;
          if (team2ColInc === gridColumns) {
            team2ColInc = 0;
            team2RowInc++;
          }
        }
      }
    }

    AppDispatcher.handleViewAction({
      actionType: AppConstants.MAX_PLAYER_COUNT,
      count: this.maxPlayerCount,
    });

    AppDispatcher.handleViewAction({
      actionType: AppConstants.TEAM_1_ROWS,
      rows: this.team1Rows,
    });

    AppDispatcher.handleViewAction({
      actionType: AppConstants.TEAMS_EVEN_ROWS,
      even: this.evenRows,
    });
  },


  /**
   * Returns the width and height of each playerData
   * @returns {Object} The width and height of each player
   */
  _getItemSize() {
    const windowSize = this.state.windowSize;
    const team1AreaElement = document.getElementsByClassName('team-1-area')[0];
    let gridColumns = 6;
    let gridRows = 3;
    let contentHeight = (windowSize.height - 250) / 2;

    if (windowSize.width > this.largeBreakpoint) {
      gridColumns = 4;
      gridRows = 3;

      if (this.maxPlayerCount > 12) {
        gridColumns = 5;
        gridRows = 4;
      }

      if (this.maxPlayerCount > 20) {
        gridRows = 5;
      }
    }

    if (this.props.isIOS && team1AreaElement) {
      // hack to accomodate browser chrome appearing/dissappearing on iOS
      contentHeight = team1AreaElement.offsetHeight - 70;
    }
    let contentWidth = windowSize.width - 30;

    if (contentWidth > this.largeBreakpoint) {
      contentWidth = (windowSize.width / 2) - 150;
      contentHeight = windowSize.height - 260;
    }

    const columnWidth = contentWidth / gridColumns;
    const rowHeight = contentHeight / gridRows;

    return {
      width: columnWidth,
      height: rowHeight,
    };
  },


  /**
   * Finds a player's division id for the provided category
   * @param {Object} playerData - The player data object
   * @param {Number} categoryId - The id of the category
   * @returns {Number} The divisionId
   */
  _findDivisionId(playerData, categoryId) {
    for (const value of playerData.categories) {
      if (value.categoryId === categoryId) {
        return value.divisionId;
      }
    }
  },


  /**
   * Called when a CHANGE event is emitted from the TeamsStore
   * @returns {undefined} undefined
   */
  _onTeamsChange() {
    const _this = this;
    clearTimeout(this.animateInHeadersTimeout);

    const teamsState = Object.assign({}, TeamsStore.getState());
    const newState = Object.assign(teamsState, { transitionSort: true });

    this.setState(newState);

    this.cycleCount++;

    this.animateInHeadersTimeout = setTimeout(function () {
      _this.setState({
        currentSortCategory: _this.state.sortCategory,
        transitionSort: false,
      });
    }, 310);
  },


  /**
   * Called when a CHANGE event is emitted from the ResizerStore
   * @returns {undefined} undefined
   */
  _onResizerChange() {
    this.setState(ResizerStore.getState());
  },
});

export default Teams;
